/**
 * Framework-independent overlay lifecycle. Hosts install/remove concrete DOM
 * listeners and execute focus restoration, but do not decide when to close.
 */
export function overlayLifecycleTransition(state, intent) {
    const unchanged = () => ({
        state,
        effect: "none",
        restoreFocus: false,
        announce: null,
    });
    if (intent.type === "destroy") {
        return state.open
            ? { state: { open: false }, effect: "teardown", restoreFocus: false, announce: null }
            : unchanged();
    }
    if (intent.type === "toggle") {
        if (intent.disabled || !intent.available)
            return unchanged();
        return state.open
            ? { state: { open: false }, effect: "teardown", restoreFocus: false, announce: "closed" }
            : { state: { open: true }, effect: "setup", restoreFocus: false, announce: "opened" };
    }
    if (intent.type === "open") {
        if (state.open || intent.disabled || !intent.available)
            return unchanged();
        return { state: { open: true }, effect: "setup", restoreFocus: false, announce: "opened" };
    }
    const shouldClose = state.open && (intent.type === "close" ||
        intent.type === "escape" ||
        (intent.type === "outside" && intent.outside));
    if (!shouldClose)
        return unchanged();
    return {
        state: { open: false },
        effect: "teardown",
        restoreFocus: intent.type === "escape" || (intent.type === "close" && intent.restoreFocus === true),
        announce: "closed",
    };
}
